import Checkbox from "./Checkbox"

import { BaseComponent, BaseState } from '../BaseComponent'

interface MultipleProps {
    id: string | undefined
    label: string | undefined
    value: string | undefined
    options: any
    error: string | undefined
    callBack: Function
    isMultiple?: boolean
}

interface MultipleState extends BaseState {
    hasFocus: boolean
}

class MultipleCheckbox extends BaseComponent<MultipleProps, MultipleState> {

    constructor (props: any) {
        super(props)

        this.state = {
            hasFocus: false
        }

        this.updateValue = this.updateValue.bind(this)
        this.isSelect = this.isSelect.bind(this)
    }

    render () {
        const labelTag = this.getLabel()

        const classString = 'form-group ' + (
            ((this.notEmpty(this.props.value) && this.props.error === undefined) ? 'is-ok ' : '') +
            (this.props.error !== undefined ? ' is-invalid' : '') +
            (this.state.hasFocus ? 'focus ' : '') 
        )

        const values: any = (this.props.value !== undefined) ? this.props.value.split('|') : undefined

        return (
            <>
                { (this.props.id) &&
                    <div className={classString} id={this.props.id}>
                        {labelTag !== undefined && labelTag}

                        {
                            this.props.options &&
                                Object.entries(this.props.options).map( ([k,v]) => {
                                    const key: string = k
                                    const val: string = v as string
                                    const isSelect: boolean = this.isSelect(key, values)

                                    return (
                                        <div key={'container' + key}>
                                            <Checkbox
                                                id={ this.props.id + '_' + key } name={key} key={key}
                                                checked={ isSelect }
                                                value={ key }
                                                getValueCallBack={ this.updateValue }
                                            >
                                                {val}
                                            </Checkbox>
                                        </div>
                                    )
                                })
                        }
                    </div>
                }
            </>
        )
    }

    private updateValue (val: string, add: boolean) {
        this.props.callBack(val, add)
    }

    private isSelect (key: string, values: any) : boolean {
        return (values === undefined) 
            ? this.props.value === key
            : values.includes(key)
    }
}

export default MultipleCheckbox